import React, { Component } from 'react';

import Answer from '../Answer';
import UnderlinedText from '../../UnderlinedText';

import { track } from 'utils/analytics';
import { isMobilePortrait } from 'utils/device';

import './index.css';

export default class Question extends Component {
	constructor(props) {
		super(props);

		this.state = {
			pointerEvents: false,
			selected: null,
			transition: 'none'
		}

		this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
		this.handleAnswerSelect = this.handleAnswerSelect.bind(this);
	}

	handleAnimationEnd() {
		this.setState(() => ({
			pointerEvents: true,
			transition: 'none'
		}));
	}

	handleAnswerSelect(text, index, idx) {
		const { onClick, question: { question, answers } } = this.props;

		track('answered', `${answers[idx].text} ${idx}`);
		this.setState(() => ({
			selected: idx
		}));
		// console.log('text', answers[idx]);

		setTimeout(() => onClick.call(this, answers[idx].index + 1), 800);
	}
	
	componentDidUpdate(prevProps, prevState) {
		if (this.props.quiz.current === this.props.index && this.state.transition !== 'in') {
			track('visible', `quiz question ${this.props.index + 1}`);
			setTimeout(() => {
				this.setState(() => ({
					pointerEvents: true,
					transition: 'in',
					selected: null
				}));
			}, this.props.index === 0 ? 400 : 10);
		} else if (this.props.quiz.current !== this.props.index && this.state.transition === 'in') {
			this.setState(() => ({
				pointerEvents: false,
				transition: 'out'
			}));
		}
	}

	render() {
		const { index, themes,  question: { question, answers, backgroundDesktop, backgroundMobile, influencer } } = this.props;
		const { pointerEvents, transition, selected } = this.state;
		const children = question.split(/\n/g);
		const right = false;//index % 2;
		const answerTextColor = 'white';
		const textColor = 'white';
		const answersStyle = { color: answerTextColor, pointerEvents: pointerEvents ? 'auto' : 'none' };

		return (
			<div className={`question ${transition} ${right ? 'right' : ''}`}
				ref={instance => this.container = instance} style={{backgroundImage: `url(${isMobilePortrait() ? backgroundMobile : backgroundDesktop})`}}>
				<div className="content-wrapper">
					<div className="answer-container">
					{isMobilePortrait() ? <div className={`hero`} style={{color: 'white'}}
								ref={instance => this.question = instance}>
								{children.map((line, i) =>
									<UnderlinedText className={`animate-line animated ${transition}`} key={`question-${i}`} text={line} colour={'#00ffff'} />)}
							</div> : null}
						<div className="image-container">
							<img src={influencer} className="image" alt="answers" />
							{/* <div className={`number number-${index}`}>{index+1}</div> */}
						</div>
						<div className={`answers`} style={answersStyle}
							ref={instance => this.answers = instance}>
							{!isMobilePortrait() ? <div className={`hero`} style={{color: 'white'}}
								ref={instance => this.question = instance}>
								{children.map((line, i) =>
									<UnderlinedText className={`animate-line animated ${transition}`} key={`question-${i}`} text={line} colour={'#00ffff'} />)}
							</div> : null}
							{answers.map(({ text }, idx) => {
								if (text === undefined) return null;
								return <Answer ref={instance => this.answer = instance}
									index={index} textColor={textColor} transition={transition}
									idx={idx} text={text} answers={answers}
									handleSelect={() => this.handleAnswerSelect(text, index, idx)} onAnimationEnd={this.handleAnimationEnd}
									selected={idx === selected}
									key={`answer-${idx}`} />})}
						</div>
					</div>
				</div>
			</div>
		);
	}
};



// WEBPACK FOOTER //
// ./src/components/Quiz/Question/index.js